import {
	US_LOCALE,
	DOLLAR_SIGN,
	NEGETIVE_DOLLAR_SIGN,
	HYPEN,
} from '../constants/constant';

export const selectedHierarchyRhId = (selectedHierarchy) => {
	let hierarchyFilterRhId = '';
	selectedHierarchy?.rhIds?.forEach((rhId) => {
		hierarchyFilterRhId += rhId + ',';
	});
	return hierarchyFilterRhId?.slice(0, -1);
};

export const currencyFormatter = (params) => {
	const value = Number(params.value);
	if (params.value === null) {
		return '-';
	}
	if (value === 0) {
		return (
			DOLLAR_SIGN +
			value.toLocaleString(US_LOCALE, {
				maximumFractionDigits: 2,
			})
		);
	}
	if (!value) {
		return '-';
	}

	if (value < 0) {
		return (
			NEGETIVE_DOLLAR_SIGN +
			Math.abs(value).toLocaleString(US_LOCALE, {
				maximumFractionDigits: 2,
			})
		);
	} else {
		return (
			DOLLAR_SIGN +
			value.toLocaleString(US_LOCALE, {
				maximumFractionDigits: 2,
			})
		);
	}
};

export const decimalSeparator = (params) => {
	const value = Number(params.value);
	if (!value && value !== 0) {
		return '';
	}
	if (value < 0) {
		return (
			HYPEN +
			Math.abs(value).toLocaleString(US_LOCALE, {
				maximumFractionDigits: 2,
			})
		);
	} else {
		return value.toLocaleString(US_LOCALE, {
			maximumFractionDigits: 2,
		});
	}
};

export const percentageFormatter = (params) => {
	const value = Number(params.value);
	if (!value && value !== 0) {
		return '';
	}
	return Number(value).toFixed(2) + '%';
};

export const numericalComparator = (valueA, valueB) => {
	return valueA - valueB;
};

export const transCustAttrResp = (edges) => {
	const customAttributeNames = [];
	edges.forEach((edge) => {
		const AttributeNames = edge?.node?.names;
		const attribute = {};
		attribute['label'] = AttributeNames?.name;
		attribute['value'] = AttributeNames?.name;
		attribute['name'] = AttributeNames?.name;
		attribute['id'] = AttributeNames?.id;
		customAttributeNames.push(attribute);
	});
	return customAttributeNames;
};

export const currencyFormatterWithHiphen = (params) => {
	const value = Number(params.value);
	if (!value) {
		return '-';
	}
	if (value < 0) {
		return (
			NEGETIVE_DOLLAR_SIGN +
			Math.abs(value).toLocaleString(US_LOCALE, {
				maximumFractionDigits: 2,
			})
		);
	} else {
		return (
			DOLLAR_SIGN +
			value.toLocaleString(US_LOCALE, {
				maximumFractionDigits: 2,
			})
		);
	}
};
export const percentageFormatterWithHyphen = (params) => {
	if (params.value === null) {
		return '-';
	}
	const value = Number(params.value);

	if (!value && value !== 0) {
		return '-';
	}
	return Number(value).toFixed(2) + '%';
};

export const valueFormatterWithHyphen = (params) => {
	if (params.value === null) {
		return '-';
	}
	const value = Number(params.value);

	if (!value && value !== 0) {
		return '-';
	}
	return value;
};

export const nameFormatterWithHyphen = (params) => {
	if (!params.value) {
		return '-';
	}
	return params.value;
};
